<template>
  <div class="test">
    <div class="wrapper">
      <h2>Тестовое задание от ООО "Дрим Тим"</h2>

      <div class="test-text">

        <div class="test-text__name">Задание:</div>

        <p class="test-text__p">
          Сверстать по макету в Figma.
        </p>

        <p class="test-text__p">
          Исходники верстки: <a href="https://github.com/kandinskiy/test-dt" title="" target="_blank">https://github.com/kandinskiy/test-dt</a>
        </p>

        <p class="test-text__p">
          <a href="/test/dreamte/index.html" title="" target="_blank">Итог выполнения</a>
        </p>

      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: "tkb",

  data () {
    return {

    }
  },

  methods: {

  }
}
</script>

<style lang="scss" scoped>
  .test {
    position: relative;
    margin: 30px 0 0;
  }

  .test-text {
    position: relative;

    &__name {
      margin: 20px 0 0;
      text-align: center;
      font-size: 16px;
      font-weight: bold;

      @media screen and (min-width: 768px){
        text-align: left;
      }
    }

    &__p {
      margin: 25px 0 0;
      padding: 0;
    }
  }

</style>
